import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/mangas';
import { categories } from '@/mocks/categories';

export default function MangaCard({ manga }: { manga: Manga }) {
  const cat = categories.find((c) => c.id === manga.categoryId);
  return (
    <Link
      to={`/category/${manga.categoryId}`}
      className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-56 w-full overflow-hidden sm:h-64">
        <img
          src={manga.cover}
          alt={`${manga.title} 漫画封面`}
          title={`${manga.title} 最新章节 · ${manga.latestChapter}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-background-950/70 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
          {manga.status}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
          <i className="ri-star-fill text-[10px]" />
          {manga.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-4">
        <h3 className="truncate text-base font-bold text-foreground-950 group-hover:text-primary-700">
          {manga.title}
        </h3>
        <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
          <span>{cat?.name}</span>
          <span className="h-3 w-px bg-background-300" />
          <span className="truncate">{manga.latestChapter}</span>
        </p>
        <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-600">
          <span className="flex items-center gap-1">
            <i className="ri-user-follow-line" />
            {(manga.followers / 10000).toFixed(1)}万追更
          </span>
          <span className="flex items-center gap-1 text-accent-600">
            <i className="ri-notification-3-line" />
            {manga.releaseDay}更新
          </span>
        </div>
      </div>
    </Link>
  );
}